/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

/* React Boostrap */
import Footer from "../components/main/Footer"

/* Components */
import { Topbar } from "../components/organisms/Topbar"
import { initPdiComponent } from "../core/service/BusinessLogicService"

/* Utils */
import { loc } from "../core/utils"
import React, { Component } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"

class ComeBackLaterPage extends Component {
  state = {}

  componentDidMount() {
    initPdiComponent("ComeBacklaterPage")
  }

  render() {
    return (
      <Container fluid>
        <Row noGutters>
          <Col className="misc-block">
            <Row>
              <Topbar tunnelData={this.props?.tunnelData} displayToggleButton={false} history={this.props?.history} />

              <Col sm={12}>
                {/* CONTENT */}
                <Container>
                  <Row className="justify-content-center">
                    <Col xs={11} sm={10} md={10} lg={5} className="hard-shadow-white-block text-center misc-mono-block">
                      <span className="ico-warning-background">
                        <i className="far fa-clock"></i>
                      </span>
                      <h1>{loc`Pending request`}</h1>
                      <p>{loc`You have 2 days to finalize your request by uploading your supporting documents.`}</p>
                      <p>{loc`We will send you an email allowing you to finalize your file later.`}</p>
                      <Button href={"/?tenant=" + this.props?.tunnelData?.tenant} variant="primary">
                        {loc`Back`}
                      </Button>
                    </Col>
                  </Row>
                </Container>
                {/* END CONTENT */}
              </Col>
              <Col sm={12}>
                <Container>
                  <Footer tunnelData={this.props?.tunnelData} />
                </Container>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default ComeBackLaterPage
